import { Text } from "../../components/Text";
import { useSubscription } from "../../auth/Subscription";
import Button from "../../components/Button";
import { format } from "date-fns";
import axios from "axios";
import { Flex } from "components/Flex";
import { useState } from "react";
import Modal from "components/Modal";
import { FormInput } from "components/FormInput";
import Loader from "components/Loader";
import { useHistory } from "react-router";

const CodeModal = ({ onClose }: { onClose: () => void }) => {
  const [code, setCode] = useState("");
  const [, setSubscription] = useSubscription();
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const redeem = () => {
    if (code.trim() === "") {
      return window.alert("Please enter a code");
    }
    setLoading(true);
    axios
      .post("/api/subscriptions/redeem", { code: code.trim() })
      .then(({ data }) => {
        setSubscription(data);
        history.push("/subscribe/success");
      })
      .catch((err) => {
        window.alert("There was an error: " + err?.response?.data ?? "Unknown");
        setLoading(false);
      });
  };

  return (
    <Modal onClose={onClose} width={400}>
      {loading && <Loader overlay />}
      <Text fontSize={4} mb={2}>
        Enter your coupon code.
      </Text>
      <Text fontSize={2} mb={3}>
        Note: This is for purchased codes from services like AppSumo. If you
        have a discount code, use it in the checkout when purchasing a
        subscription
      </Text>
      <FormInput
        label="Coupon Code"
        value={code}
        onChange={(ev) => setCode(ev.target.value)}
        autoFocus
      />
      <Button onClick={redeem}>Redeem</Button>
    </Modal>
  );
};

const SubscriptionSettings = () => {
  const [subscription, setSubscription] = useSubscription();
  const [showCodeModal, setShowCodeModal] = useState<boolean>(false);

  const cancelSub = async () => {
    if (window.confirm("Are you sure you want to cancel your subscription?")) {
      const { data: sub } = await axios.delete("/api/subscriptions");
      setSubscription(sub);
    }
  };

  return (
    <div>
      {showCodeModal && <CodeModal onClose={() => setShowCodeModal(false)} />}
      <Text fontWeight={600} fontSize={4} mb={2}>
        Subscription Settings
      </Text>
      {subscription.type === "expired" ? (
        <div>
          <Text mb={2}>Subscription: Expired</Text>
          <Flex>
            <Button to="/subscribe">Upgrade Now</Button>
            <Button onClick={() => setShowCodeModal(true)} ml={2}>
              Redeem Code
            </Button>
          </Flex>
        </div>
      ) : subscription.type === "founder" ? (
        <div>
          <p>Subscription: Founder</p>
        </div>
      ) : subscription.type === "free-trial" ? (
        <div>
          <Text mb={1}>Subscription: Free Trial</Text>
          <Text mb={3}>
            Your free trial will end on{" "}
            <strong>
              {format(new Date(subscription.periodEnd), "yyyy-MM-dd")}
            </strong>
          </Text>
          <Flex>
            <Button to="/subscribe">Upgrade Now</Button>
            <Button onClick={() => setShowCodeModal(true)} ml={2}>
              Redeem Code
            </Button>
          </Flex>
        </div>
      ) : subscription.cancelAtPeriodEnd ? (
        <div>
          <Text mb={1}>
            Subscription: <strong>Cancelled</strong>
          </Text>
          <Text mb={3}>
            Your subscription will end on:{" "}
            <strong>
              {format(new Date(subscription.periodEnd), "yyyy-MM-dd")}
            </strong>
          </Text>
        </div>
      ) : (
        <div>
          <Text mb={1}>
            Subscription: <strong>Active</strong>
          </Text>
          <Text mb={3}>
            Your subscription will automatically renew on:{" "}
            <strong>
              {format(new Date(subscription.periodEnd), "yyyy-MM-dd")}
            </strong>
          </Text>
          <Button color="danger" onClick={cancelSub}>
            Cancel Subscription
          </Button>
        </div>
      )}
    </div>
  );
};

export default SubscriptionSettings;
